<template>
  <div class="w-full">
    <div class="float-tile white-tile top-tile" />
    <div class="float-tile transparent-tile left-24 -top-14 bg-gradient-to-b from-blue-start to-blue-end top-tile" />
    <div class="flex justify-center items-start min-h-screen z-10 relative">
      <div class="w-full md:w-8/12 ">
        <div class="rounded p-5">
          <logo class="w-80 mb-8" />

          <div class="card-body">
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Description of Service</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">Betslip.tips is a platform that uses machine learning and artificial intelligence to publish tips on several platforms, including an inhouse app. Some of these services will be free of charge, others may cost money or have other requirements. The requirements or fees for any service or option will be clearly explained and separately agreed to when a Member implements those options if any. In order to navigate and make full use of Betslip.tips, you are responsible to ensure you have a device which is connected successfully to the internet. Only the information that reaches Sociobet’s servers will be considered official.</p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Conduct, Consent, and Responsibility</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">By agreeing to these Terms & Conditions you recognize and have full awareness that anything you post to Betslip.tips, being text, image, video, sound or any other format, is your full responsibility, whether being legit, fraudulent, abusive or indecent. As such, Betslip.tips has no responsibility in such content and will cooperate with any legal entity that needs investigation in extreme cases. Should such activity be spotted by Betslip.tips, an immediate suspension of account will follow.
                </p>
                <p class="dark:text-white">
                  Betslip.tips condemns: 
                <ul class="mt-4">
                  <li class="ml-5 dark:text-white list-disc">Use of this site if you are a minor</li>
                  <li class="ml-5 dark:text-white list-disc">Use of this site if you have a gambling addiction</li>
                  <li class="ml-5 dark:text-white list-disc">Abuse or Racism</li>
                  <li class="ml-5 dark:text-white list-disc">Exposure of someone else’s sensitive information</li>
                  <li class="ml-5 dark:text-white list-disc">Fraud</li>
                  <li class="ml-5 dark:text-white list-disc">Promoting match-fixing</li>
                  <li class="ml-5 dark:text-white list-disc">Trademark Infringement</li>
                </ul>
                </p>
                
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Content Ownership</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">Betslip.tips does not claim ownership on any content you upload to your Betslip.tips space. If you choose to have this information public, Betslip.tips will share all content with its users. Betslip.tips has the privilege to remove any content which is deemed violating Terms of Use. Betslip.tips condemns sharing paid service information on your free page, in these cases, Betslip.tips has the right to remove content and suspend your account.
                </p>
                <p class="dark:text-white">
                  You agree that you must evaluate, and bear all risks associated with, the use of any Content, including any reliance on the accuracy, completeness, or usefulness of such Content.
                </p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Resale of our services</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or access to the Service.
                </p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Service changes</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">Betslip.tips reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice. You agree that Betslip.tips shall not be liable to you or to any third party for any modification, suspension or discontinuance of the Service.
                </p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Termination</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">You agree that Betslip.tips has the right to terminate your account, at any given time, if there is a reason to believe you violated the Terms of Use, irrespective of any unspent credit/balance. In addition, you agree that these funds will not be returned and Betslip.tips will not be held responsible.
                </p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Advertisements</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">Betslip.tips will portray different advertisements from time to time. You accept to see such advertisements
                </p>
              </div>
            </div>
            <div class="flex mb-16 gap-8 text-left">
              <div class="w-4/12 ">
                <h1 class="mb-2 text-bs-gray dark:text-bs-blue-dark text-3xl font-black">Disclaimer</h1>
              </div>
              <div class="w-6/12">
                <p class="dark:text-white">Using, following &amp; posting to Betslip.tips is at your own risk. Betslip.tips does not warrant its users to:
                  <ul class="mt-4">
                    <li class="ml-5 dark:text-white list-disc" >Make a living off our services</li>
                    <li class="ml-5 dark:text-white list-disc" >Having an uninterrupted service</li>
                    <li class="ml-5 dark:text-white list-disc" >Have an error/mistake/bugs free product</li>
                    <li class="ml-5 dark:text-white list-disc" >Content, information, ads, discussion to be up to your expectation</li>
                    <li class="ml-5 dark:text-white list-disc" >Any downloadable content which was posted to a public space to be malware free</li>
                  </ul>
                </p>
                <p class=" dark:text-white mt-4" >As such, Betslip.tips is not responsible for any losses/damages that might be experienced because of the above or any other matter. Betslip.tips services help in making an informed decision, but you are the sole responsible for your actions.
                  </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="float-tile white-tile fixed-bottom-tile-position bottom-tile" />
    <div class="float-tile transparent-tile right-24 -bottom-20 bg-gradient-to-b from-green-start to-green-end bottom-tile" />
  </div>
</template>


<script>
import Logo from "@/components/atoms/Logo.vue"

export default {
  components: {
    Logo
  }
};
</script>